import { Button } from "@material-ui/core";
import UsersTable from "../../Components/Admin/Users/UsersTable";
import { auth } from "../../firebase";

function Login() {
  return <UsersTable /> 
}

export default Login;
